export const each = (iterable, func) => {
    return iterable.reduce((result, current, index) => {
        if (!result) {
            return func(current, index);
        }
        return result.then(() => func(current, index));
    }, Promise.resolve());
};